import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RedirectToMap from "../../../../constants/MapConstants";
import useRedirectToHome from "../../../../utility/redirectfunctions";
import ROUTES from "../../../../constants/RouteData";

const footerLinks1 = ["Personal Loan", "Business Loan", "PayOff"];
const footerLinks2 = ["RBI Sachet", "FAQs", "EMI Calculator"];
const footerLinks3 = ["Digital Lending Partners", "Contact us", "Unsubscribe"];

const mobileFooterLinks1 = [
  "Personal Loan",
  "Business Loan",
  "PayOff",
  "RBI Sachet",
  "EMI Calculator",
];

const mobileFooterLinks2 = [
  "FAQs",
  "Digital Lending Partners",
  "Contact us",
  "Unsubscribe",
];

const FooterSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigateToHome = useRedirectToHome();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const socialIcons = [
    {
      Icon: "/assets/img/fb.png",
      href: "https://www.facebook.com/DigitMoneyTechnologies",
    },
    {
      Icon: "/assets/img/instagram.png",
      href: "https://www.instagram.com/digitmoney.india/#",
    },
    {
      Icon: "/assets/img/LinkedInImg.png",
      href: "https://www.linkedin.com/company/digitmoney/",
    },
    { Icon: "/assets/img/youtube.png", href: "#" },
    { Icon: "/assets/img/twitterX.png", href: "https://x.com/DigitMoneyIndia" },
    {
      Icon: "/assets/img/whatsappB.png",
      href: "https://api.whatsapp.com/send/?phone=9076324177&type=phone_number&app_absent=0",
    },
  ];

  const getLinkPath = (label) => {
    switch (label.toLowerCase()) {
      case "contact us":
        return ROUTES.contactUs;
      case "unsubscribe":
        return ROUTES.dndService;
      case "terms of use":
      case "terms & conditions":
      case "privacy policy":
        return ROUTES.termsOfUsage;
      case "faqs":
        return `${ROUTES.home}#faq`;
      case "emi calculator":
        return `${ROUTES.home}#emiCalculator`;
      case "personal loan":
        return ROUTES.personalLoan;
      case "business loan":
        return ROUTES.businessLoan;
      case "digital lending partners":
        return ROUTES.partners;
      case "rbi sachet":
        return "https://sachet.rbi.org.in/";
      case "payoff":
        return "https://payoff.club/";
      default:
        return null;
    }
  };

  const MobileFooter = () => (
    <footer className="bg-black w-full min-h-fit text-white px-4 py-10 z-0">
      <div className="max-w-7xl mx-auto flex flex-col justify-center items-start gap-6">
        {/* Logo */}
        <div className="w-full max-w-5xl">
          <img
            src="/assets/img/newLogo.png"
            onClick={navigateToHome}
            alt="Company Logo"
            height="24"
            width="142"
            className="cursor-pointer"
          />
        </div>

        {/* Tagline */}
        <h1
          style={{ fontFamily: "myFirstFont" }}
          className="[@media(max-width:340px)]:text-[25px] text-[35px] text-left w-full"
        >
          Quick & Hassle-Free Personal Loan
        </h1>

        {/* Mobile Footer Links */}
        <div
          style={{ fontFamily: "Atkinson-regular" }}
          className="grid grid-cols-2 mt-2 gap-6 text-[14px] text-gray-300"
        >
          <div className="space-y-1 flex flex-col gap-2.5">
            {mobileFooterLinks1.map((label, i) => {
              const path = getLinkPath(label);
              return path ? (
                <Link
                  key={i}
                  to={path}
                  reloadDocument={true}
                  className="hover:text-white transition-colors"
                >
                  {label}
                </Link>
              ) : (
                <p key={i}>{label}</p>
              );
            })}
          </div>
          <div className="space-y-1 flex flex-col gap-2.5">
            {mobileFooterLinks2.map((label, i) => {
              const path = getLinkPath(label);
              return path ? (
                <Link
                  key={i}
                  to={path}
                  reloadDocument={true}
                  className="hover:text-white transition-colors"
                >
                  {label}
                </Link>
              ) : (
                <p key={i}>{label}</p>
              );
            })}
          </div>
        </div>

        {/* Address */}
        <div className="flex flex-col gap-6 text-sm text-[#717171] w-full">
          <div style={{ fontFamily: "Atkinson-regular" }}>
            <b className="text-green-600 text-[18px]">
              DigitMoney Technologies Private Limited.
            </b>{" "}
            <br />
            <br />
            <p
              className=" text-[18px] xs:text-[15px] hover:text-green-400 cursor-pointer"
              onClick={RedirectToMap}
            >
              1341 Regus Platinum <br className="block" />
              Business Centre Pvt Ltd,
              <br />
              Level 13, Platinum Techno Park,
              <br />
              Plot No. 17 & 18, Sector 30A, Vashi,
              <br />
              Navi Mumbai - 400705
            </p>
          </div>

          <div
            style={{ fontFamily: "Atkinson-regular" }}
            className="block mt-2"
          >
            <p className="text-[14px]">Grievance Redressal Officers</p>
            <p className="text-[14px]">
              Ammy Pinheiro:{" "}
              <a href="mailto:grievance@digitmoney.in" target="_blank">
                grievance@digitmoney.in
              </a>
              Contact Phone: 9820016988
            </p>
          </div>
        </div>

        {/* Mobile Social Icons */}
        <div className="flex w-full items-center gap-4 flex-wrap mt-6 mb-5">
         {socialIcons.map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group h-[25px] w-[25px] rounded-full flex items-center justify-center transition-all"
                >
                  <div
                    className="h-full w-full bg-gray-400 group-hover:bg-green-500 transition-colors duration-300"
                    style={{
                      WebkitMask: `url(${Icon}) center / contain no-repeat`,
                      mask: `url(${Icon}) center / contain no-repeat`,
                    }}
                  ></div>
                </a>
              ))}
        </div>

        {/* Mobile Bottom */}
        <div
          className="text-[#4B4B4B] text-[14px] space-y-4 w-full"
          style={{ fontFamily: "Atkinson-regular" }}
        >
          <hr className="border-gray-700" />
          <div className="flex flex-col gap-2 py-6">
            <Link
              to={ROUTES.termsOfUsage}
              reloadDocument={true}
              className="hover:text-white transition"
            >
              Terms of Use
            </Link>
            <Link
              to={ROUTES.privacyPolicy}
              reloadDocument={true}
              className="hover:text-white transition"
            >
              Privacy Policy
            </Link>
          </div>
          <hr className="border-gray-700" />
          <p className="text-left py-4 text-[12px]">
            &copy; 2025,{" "}
            <a
              href="https://digitmoney.in/"
              className="hover:text-green-500"
            >
              DigitMoney Technologies Private Limited.
            </a>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );

  const DesktopFooter = () => (
    <footer className="bg-black w-full min-h-content text-white px-4 py-10 md:py-8 z-0">
      <div className="max-w-7xl mx-auto flex flex-col justify-center items-center gap-6 pt-[80px]">
        {/* Logo */}
        <div className="w-full max-w-5xl">
          <img
            src="/assets/img/newLogo.png"
            onClick={navigateToHome}
            alt="Company Logo"
            height="24"
            width="142"
            className="cursor-pointer"
          />
        </div>

        {/* Tagline */}
        <h4
          style={{ fontFamily: "myFirstFont" }}
          className="w-full text-5xl mb-4"
        >
          Quick & Hassle-Free Personal Loan
        </h4>

        {/* Row 3: Info + Links */}
        <div className="flex w-full max-w-5xl flex-col md:flex-row justify-between gap-3">
          {/* Address */}
          <div className="flex flex-col gap-6 text-sm text-gray-400 md:w-1/2">
            <div style={{ fontFamily: "Atkinson-regular" }}>
              <b className="text-green-600 text-[18px]">
                DigitMoney Technologies Private Limited.
              </b>{" "}
              <br />
              <br />
              <p
                className="text-[18px] hover:text-green-400 cursor-pointer"
                onClick={RedirectToMap}
              >
                1341 Regus Platinum Business Centre Pvt Ltd,
                <br />
                Level 13, Platinum Techno Park,
                <br />
                Plot No. 17 & 18, Sector 30A, Vashi,
                <br />
                Navi Mumbai - 400705
              </p>
            </div>

            <div
              style={{ fontFamily: "Atkinson-regular" }}
              className="block mt-2"
            >
              <p className="text-[14px]">Grievance Redressal Officers</p>
              <p className="text-[14px]">
                Ammy Pinheiro:{" "}
                <a href="mailto:grievance@digitmoney.in" target="_blank">
                  grievance@digitmoney.in
                </a>
                <br />
                Contact Phone: 9820016988
              </p>
            </div>

            {/* Socials */}
            <div className="flex items-center gap-4 flex-wrap mt-6 mb-5">
              {socialIcons.map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group h-[25px] w-[25px] rounded-full flex items-center justify-center transition-all"
                >
                  <div
                    className="h-full w-full bg-gray-400 group-hover:bg-green-500 transition-colors duration-300"
                    style={{
                      WebkitMask: `url(${Icon}) center / contain no-repeat`,
                      mask: `url(${Icon}) center / contain no-repeat`,
                    }}
                  ></div>
                </a>
              ))}
            </div>
          </div>

          {/* Desktop Footer Links */}
          <div
            style={{ fontFamily: "Atkinson-regular" }}
            className="grid grid-cols-3 gap-6 text-[14px] text-gray-300"
          >
            {[footerLinks1, footerLinks2, footerLinks3].map((group, index) => (
              <div key={index} className="space-y-1 flex flex-col gap-2.5">
                {group.map((label, i) => {
                  const path = getLinkPath(label);
                  return path ? (
                    <Link
                      key={i}
                      reloadDocument={true}
                      to={path}
                      target={
                        label === "RBI Sachet" || label === "PayOff"
                          ? "_blank"
                          : "_self"
                      }
                      className="hover:text-white transition-colors"
                    >
                      {label}
                    </Link>
                  ) : (
                    <p key={i}>{label}</p>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Bottom */}
        <div
          style={{ fontFamily: "Atkinson-regular" }}
          className="border-t-[2px] border-[#4B5466] pt-10 text-center text-[12px] text-[#525252] md:flex md:w-full md:justify-between md:items-center"
        >
          <div className="flex flex-col md:flex-row justify-center items-center gap-[10px] md:gap-[30px]">
            <Link
              to={ROUTES.termsOfUsage}
              reloadDocument={true}
              className="hover:text-gray-300 cursor-pointer"
            >
              Terms of Use
            </Link>
            <Link
              to={ROUTES.privacyPolicy}
              reloadDocument={true}
              className="hover:text-gray-300 cursor-pointer"
            >
              Privacy Policy
            </Link>
          </div>
          <p className="">
            {" "}
            &copy; 2025,{" "}
            <a
              href="https://digitmoney.in/"
              className="hover:text-green-500"
            >
              DigitMoney Technologies Private Limited.
            </a>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );

  return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default FooterSection;
